/**
 * Escapes a single CSV cell value per RFC 4180.
 * Wraps the value in double-quotes if it contains a comma, double-quote,
 * or newline, and escapes any embedded double-quotes by doubling them.
 */
export function csvEscapeCell(value: string): string {
    // If the value contains any special characters,
    // wrap it in double quotes and escape internal double quotes
    if (/[,'"\n\r]/.test(value)) {
        return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
}

export const createCSVContent = (header: string, rows: string[]) => {
    const csvContent = 'data:text/csv;charset=utf-8,';
    return encodeURI(csvContent + header + rows.join(''));
};

export const createJSONContent = (jsonData: object[]) => {
    const jsonContent = 'data:text/json;charset=utf-8,';
    return encodeURI(jsonContent + JSON.stringify(jsonData));
};

export const downloadCreatedFile = (encodedUri: string, filename: string) => {
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
